import LegalsContentLayout from "../components/layouts/legalsScreen/LegalsContentLayout";
import LegalsContent from "../components/others/legalsScreen/LegalsContent";
import LegalsLayout from "../components/layouts/legalsScreen/LegalsLayout";
import SystemScreenTopBar from "../components/bars/SystemScreenTopBar";
import {useState} from "react";
import {useResizeListener} from "../listeners/SystemResizeListener";
import SystemAppDrawer from "../components/others/SystemAppDrawer";
import {kLegalContentKeys} from "../constants/keys";
import {Helmet} from "react-helmet";
import {buildHelmetTitle} from "../helpers/SeoHelper";

export default function LegalMentionsScreen() {
    // Used in index.js by the router as an entry point
    // for compulsory legal texts, in tablet and desktop modes

    // PROPERTIES
    const [isDrawerOpen, setIsDrawerOpen] = useState(false)

    // HOOKS
    // ---- Set listener for potential open Modal during screen resize
    useResizeListener(() => setIsDrawerOpen(false))

    // BUILD
    return (
        <div className={"animate-appearSlow overflow-auto w-full h-[100svh] flex flex-col justify-start items-center"}>
            {/** META */}
            <Helmet>
                <title>{buildHelmetTitle('Ummia - Mentions légales')}</title>
                <meta name="description"
                      content="Conditions et détails d'utilisation d'Ummia." />
            </Helmet>
            {/** MODAL */}
            <SystemAppDrawer open={isDrawerOpen}
                             handleClose={() => setIsDrawerOpen(false)} />
            {/** CONTENT */}
            <SystemScreenTopBar currentTab={null}
                                openDrawer={openDrawer} />
            <LegalsLayout>
                <LegalsContentLayout>
                    <LegalsContent legalContentKey={kLegalContentKeys.legalMentions} />
                </LegalsContentLayout>
            </LegalsLayout>
        </div>
    );

    // METHODS
    // ---- Open modal
    function openDrawer() {
        setIsDrawerOpen(true)
    }

}